module.exports = __webpack_public_path__ + "img/icon-confirm.05170139.svg";